import React, { memo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import stylesPc from "./ProgramIndex.module.css";
import stylesSp from "./ProgramIndex_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { AppState } from "../../../../root/RootReducer";
import { GetLearningProgram, GetAllProgram } from "../../../../stores/program/ProgramActions";
import { Program, Video } from "../../../../stores/program/model/Program";
import { CircularProgress, Tab, Tabs, withStyles } from "@material-ui/core";
import {
    // addRecProgram,
    // delRecProgram,
    GetRecommendProgramList,
} from "../../../../common/homePage/HomePageActions";
// import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
// import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
// import MuiAlert from "@material-ui/lab/Alert";
// import {AlertTitle} from "@material-ui/lab";
// import {isAdmin} from "../../../../user/User";
// import classNames from "classnames";
// import PersonIcon from "@material-ui/icons/Person";
// import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
//import ThumbUpIcon from "@material-ui/icons/ThumbUp";
// import Alert from "@material-ui/lab/Alert";
// import PuiTooltip from "../../../../components/elements/PuiTooltip ";
// import EpisodeList from "../../../../common/components/modal/EpisodeList";
import PuiTypography from "../../../../components/elements/PuiTypography";
// import VisibilityIcon from "@material-ui/icons/Visibility";
// import TextsmsIcon from "@material-ui/icons/Textsms";
import { useRouteMatch } from "react-router-dom";
/* import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia"; */
// import { isNullorUndefined } from "../../../../utils/ObjectUtils";
import { animateScroll } from "react-scroll";
import VideoSlideGroup from "../../../../common/components/slide/VideoSlideGroup";
import ChannelSlideGroup from "../../../../common/components/slide/ChannelSlideGroup";
import { useInitFlag } from "../../../../components/function/useInitFlag";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

interface StyledTabsProps {
    value: number;
    className: string;
    onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

const StyledTabs = withStyles({
    indicator: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        "& > span": {
            width: "100%",
            backgroundColor: "#CCCCCC",
            color: "#CCCCCC",
        },
    },
})((props: StyledTabsProps) => (
    <Tabs
        {...props}
        variant="scrollable"
        scrollButtons="on"
        TabIndicatorProps={{ children: <span /> }}
    />
));

function a11yProps(index: any) {
    return {
        id: `tab-${index}`,
        "aria-controls": `tabpanel-${index}`,
    };
}

function ProgramIndex() {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const dispatch = useDispatch();
    // const classes = useStyles();
    // const history = useHistory();
    const match = useRouteMatch<{ id: string }>();

    // プログラム一覧リスト
    const { allProgramList } = useSelector(({ program }: AppState) => program);
    const { programList, isLoading } = useSelector(({ program }: AppState) => program);
    //const {recommendProgramList} = useSelector(({recommendList}: AppState) => recommendList);
    //const [isLimitRecommendPrograms, ChangeLimitRecommendPrograms] = React.useState(false);
    const [tabIndex, setTabIndex] = React.useState<number>(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [currentVideo, setCurrentVideo] = React.useState<Video>();
    // const [ recommendProgramNum, ChangeRecommendProgramNum] = React.useState(0);

    // const [programTitle, setProgramTitle] = React.useState("");
    // const [showAddMsg, setShowAddMsg] = React.useState(false);
    // const [showDelMsg, setShowDelMsg] = React.useState(false);
    // const [init, setInit] = React.useState(true);

    // データ取得中フラグ
    const [isLoadingData, setIsLoadingData] = useInitFlag(true);
    // 初期化フラグ
    const [isInit, setIsInit] = useInitFlag(true);

    const { userInfo } = useSelector((state: AppState) => ({
        user: state.user.user,
        userInfo: state.user.userInfo,
    }));

    // TODO：修正予定
    //受講中プログラム（isLearning === true）
    let attendProgram: Program[] = [];
    if (programList && programList.length > 0) {
        attendProgram = programList.filter((row) => {
            return row.isLearning === true;
        });
    }

    //APIコール
    useEffect(() => {
        if (userInfo) {
            dispatch(GetLearningProgram(userInfo.id));
            setIsInit(false);
        }
        if (userInfo) {
            dispatch(GetAllProgram(userInfo.id));
        }
        if (userInfo) {
            dispatch(GetRecommendProgramList(userInfo.id));
        }
        // eslint-disable-next-line
    }, [dispatch, userInfo]);

    useEffect(() => {
        if (!isLoading && isLoadingData && !isInit) {
            setIsLoadingData(false);
        }
        // eslint-disable-next-line
    }, [isLoading]);

    useEffect(() => {
        const { id } = match.params;

        if (allProgramList.length > 0) {
            let index = 0;
            // eslint-disable-next-line prefer-const
            for (let program of allProgramList) {
                if (program.id === id) {
                    setTabIndex(index);
                    setCurrentVideo(selectVideo(allProgramList[index].videos));
                    /*                     animateScroll.scrollTo(270, {
                        duration: 400,
                        smooth: true,
                    }); */

                    break;
                }
                index = index + 1;
            }
        }
    }, [match, allProgramList]);

    const scrollChange = (event: React.ChangeEvent<{}>, index: number) => {
        setTabIndex(index);
        const channelListTop = document.getElementById("channelList" + index)?.offsetTop;
        const headerHeight = document.getElementById("header")?.offsetHeight;
        const tabsHeight = document.getElementById("tabs")?.offsetHeight;
        if (channelListTop && headerHeight && tabsHeight) {
            animateScroll.scrollTo(
                channelListTop - headerHeight - tabsHeight + (IsDevice("desktop") ? 30 : 80),
                {
                    duration: 400,
                    smooth: true,
                }
            );
        }
    };

    const handleScroll = useCallback(() => {
        if (!allProgramList || allProgramList.length === 0) return;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const channelListTopArray: number[] = [];
        for (let i = 0, length = allProgramList.length; i < length; i++) {
            const channelListTop = document.getElementById("channelList" + i)?.offsetTop;
            if (channelListTop) channelListTopArray.push(Math.abs(scrollTop - channelListTop));
        }

        if (channelListTopArray && channelListTopArray.length > 0) {
            const minNumber = Math.min(...channelListTopArray);
            const index = channelListTopArray.indexOf(minNumber);
            setTabIndex(index);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allProgramList]);

    useEffect(() => {
        if (!allProgramList || allProgramList.length === 0) return;
        document.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll, allProgramList]);

    // 文字列結合
    /*  useEffect(() => {
        ChangeRecommendProgramNum(Object.keys(recommendProgramList).length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recommendProgramList]); */

    if (isLoading || isLoadingData) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    // フォーカスされたビデオを決める
    const selectVideo = (videos: Video[]) => {
        if (videos.length === 1) {
            return videos[0];
        }
        if (videos.length > 1) {
            // 最新履歴の日付をとる（時間）
            const latestDate = Math.max(
                ...videos.map((item) => {
                    if (item.viewingActivities.length > 0) {
                        return Date.parse(item.viewingActivities[0].created);
                    } else {
                        return -1;
                    }
                })
            );
            for (let j = 0; j < videos.length; j++) {
                // 視聴していないビデオをスキップ
                if (videos[j].viewingActivities.length === 0) continue;
                const date = Date.parse(videos[j].viewingActivities[0].created);
                const isFinished = videos[j].viewingActivities[0].isFinished;
                if (date === latestDate && !isFinished) {
                    const latest = videos[j];
                    return latest;
                } else if (date === latestDate && isFinished) {
                    const index = j;
                    if (index === videos.length - 1) return videos[0];
                    const next = videos[j + 1];
                    return next;
                }
            }
        }
    };

    return (
        <>
            <div className={styles.root}>
                {/* 視聴中のチャンネル */}
                <div className={styles.learningPrograms}>
                    <div className={styles.learningTitle}>
                        <PuiTypography size={20} bold={true} color="white">
                            視聴中のチャンネル
                        </PuiTypography>
                    </div>
                    {attendProgram && attendProgram.length > 0 ? (
                        <div className={styles.learningGroup}>
                            <ChannelSlideGroup
                                id="受講Channel"
                                ChannelList={attendProgram}
                                displayNum={IsDevice("desktop") ? 5 : IsDevice("ipad") ? 3 : 2}
                                needLoop={false}
                            />
                        </div>
                    ) : (
                        <div className={styles.textNoContent}>視聴中のチャンネルがございません</div>
                    )}
                </div>

                {/* ナビゲーション */}
                {allProgramList && allProgramList.length > 0 && (
                    <div id="tabs" className={styles.tabs}>
                        <StyledTabs
                            value={tabIndex}
                            onChange={scrollChange}
                            aria-label="Scroll Tabs"
                            className={styles.tabsDami}
                        >
                            {allProgramList?.map((row, index) => (
                                <Tab
                                    key={row.id}
                                    label={row.title}
                                    wrapped={true}
                                    {...a11yProps(index)}
                                    className={styles.tabDetail}
                                />
                            ))}
                        </StyledTabs>
                    </div>
                )}

                {/* tab content */}
                {allProgramList &&
                    allProgramList.length > 0 &&
                    allProgramList.map((row, index) => (
                        <div id={`channelList${index}`} key={row.id} className={styles.programs}>
                            <div id={row.id} className={styles.slideTitle}>
                                <PuiTypography size={20} bold={true} color="white">
                                    {row.title}
                                </PuiTypography>
                            </div>
                            <VideoSlideGroup
                                id={row.id}
                                programList={allProgramList}
                                videoListTransition={row.videos}
                                displayNum={IsDevice("desktop") ? 5 : IsDevice("ipad") ? 3 : 2}
                                needLoop={false}
                            />
                        </div>
                    ))}
            </div>
            {/* プログラム一覧
                        {   allProgramList.length > 0 &&
                            allProgramList.map((row)=>(
                                <div key={row.id} className={styles.programs}>
                                    <div id={row.id} className={styles.slideTitle}>
                                        <div>
                                            {
                                                (recommendProgramList.filter((rec) => rec.id === row.id).length <= 0 && isAdmin(user?.roles)) &&
                                            <LibraryAddIcon 
                                                className={classes.icon} 
                                                onClick={() => handleAddRec(parseInt(row.id), row.title)} 
                                            />
                                            }
                                            {
                                                (recommendProgramList.filter((rec) => rec.id === row.id).length > 0 && isAdmin(user?.roles)) &&
                                            <RemoveCircleOutlineIcon 
                                                className={classes.icon} 
                                                onClick={() => handleDelRec(parseInt(row.id), row.title)} 
                                            />
                                            }
                                        </div>
                                        <div className={classNames(styles.titleText, {[styles.titleWithIcon]: isAdmin(user?.roles)})}>
                                            <PuiTypography size={24} bold={true}>{row.title}</PuiTypography>
                                        </div>
                                    </div>
                                    <div className={styles.detailGroup}>
                                        <SlideGroup 
                                            id={row.id} 
                                            title={row.title} 
                                            imageUrl="" 
                                            videoList={row.videos} 
                                            description={row.description}
                                            relatedVideoList={row.relatedVideos}
                                            displayNum={5} 
                                            slideBetween={5} 
                                            needLoop={false} 
                                        />
                                    </div>
                                </div>
                            ))}

                        <Snackbar open={showAddMsg} autoHideDuration={3000} onClose={closeMsg}>
                            <MuiAlert elevation={6} variant="filled" onClose={closeMsg} severity="success" >
                                <AlertTitle>おすすめProgramに登録しました</AlertTitle>
                                <li><strong>{programTitle}</strong></li>
                            </MuiAlert>
                        </Snackbar>

                        <Snackbar open={showDelMsg} autoHideDuration={3000} onClose={closeMsg}>
                            <MuiAlert elevation={6} variant="filled" onClose={closeMsg} severity="error" >
                                <AlertTitle>おすすめProgramリストから削除しました</AlertTitle>
                                <li><strong>{programTitle}</strong></li>
                            </MuiAlert>
                        </Snackbar>
                        <div>
                            <Snackbar autoHideDuration={3000} onClose={CloseLimitRecommendProgramsBar} open={isLimitRecommendPrograms}>
                                <Alert severity="error">
                                    おすすめProgramはすでに3件登録されているので追加できません
                                </Alert>
                            </Snackbar>
                        </div> */}
        </>
    );
}

export default memo(ProgramIndex);
